import { FormControl } from '@mui/material';
import { Input, InputProps } from '@sm-dashboard/ui-components';
import { Controller, useFormContext } from 'react-hook-form';

interface InputFieldProps extends InputProps {
  type?: InputProps['type'];
  min?: number;
  max?: number;
  maxLength?: number;
  name: string;
  onChangeFunction?: (value: string) => void;
}
export const InputField = ({
  type = 'text',
  min = 0,
  max,
  maxLength,
  name,
  helperText,
  onChangeFunction,
  placeholder,
  inputProps: inputPropsProp,
  ...rest
}: InputFieldProps) => {
  const { control } = useFormContext() || {};
  return (
    <FormControl fullWidth>
      <Controller
        key={name}
        name={name}
        control={control}
        render={({ field: { onChange, ...field }, fieldState: { error } }) => (
          <Input
            {...field}
            type={type}
            placeholder={placeholder}
            helperText={error?.message || helperText}
            inputProps={{
              ...inputPropsProp,
              min,
              ...(max !== undefined && { max }),
              ...(maxLength !== undefined && { maxLength })
            }}
            onChange={e => {
              onChange(e);
              onChangeFunction?.(e.target.value);
            }}
            {...rest}
          />
        )}
      />
    </FormControl>
  );
};

export default InputField;
